export function smartPrepend(prepStr, str) {
  if (str) return prepStr + str;
  return str;
}

// Helper function for obtaining a joiner object for use with .reduce() that is capable of
// (but not limited to) concatenating React elements with the given seperator in between
export function joiner(seperator) {
  return (accum, cur) => [...accum, accum.length ? seperator : undefined, cur];
}

// Helper function for deriving a boolean value from a URL query parameter such that it returns
// true iff the parameter is present and evaluates to something that is neither 0, 'false', 'no'
// or 'off'. Notably, it will return true if queryParam is the empty string (which would usually
// be considered a falsy value).
export function booleanQuery(queryParam) {
  if (queryParam === null || queryParam === undefined) return false;
  const qpStrLC = !queryParam ? queryParam.toLowerCase() : "";
  return (
    parseInt(queryParam) !== 0 &&
    qpStrLC !== "false" &&
    qpStrLC !== "no" &&
    qpStrLC !== "off"
  );
}

// Helper function for retrieving all URL query parameters except those with the given key(s)
export function selectQueriesExcept(urlSearchParams, excludedQueryParamNames) {
  let filteredParams = new URLSearchParams();
  const allParams = urlSearchParams.entries();
  for (const param of allParams) {
    let includeParam = true;
    for (const excludedParam of excludedQueryParamNames)
      if (
        param[0].localeCompare(excludedParam, undefined, {
          sensitivity: "accent",
        }) === 0
      ) {
        includeParam = false;
        break;
      }
    if (includeParam) filteredParams.append(param[0], param[1]);
  }
  return filteredParams;
}
